import { FacebookEventType } from '@/enums/events'

import { initPixel } from './pixel-init'

interface FBCustomData {
  content_category?: string
  content_ids?: [number | string]
  content_name?: string
  content_type?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  contents?: [any]
  currency?: string
  num_items?: number
  predicted_ltv?: number
  search_string?: string
  status?: boolean
  value?: number
}

function isInited(): boolean {
  return typeof window !== 'undefined' && !!window.fbq
}

const _fbq = (...args: Array<unknown>): void => {
  if (!isInited()) {
    console.warn('FBQ is not initialized')
    return
  }
  if (!!window.fbq) {
    window.fbq(...args)
  }
}

const trackPageView = (): void => {
  _fbq('track', 'PageView')
}

const init = (pixelId: string, sessionId: string): void => {
  // avoid to run initialization multiple times
  if (isInited()) return

  initPixel()

  if (!isInited()) {
    console.warn('FBQ is not initialized')
    return
  }

  _fbq('set', 'autoConfig', 'false', pixelId)

  _fbq('init', pixelId, {
    external_id: sessionId,
  })
  trackPageView()
}

const track = (
  eventName: FacebookEventType,
  customData?: FBCustomData,
  fbParams?: Record<string, unknown>
): void => {
  _fbq('track', eventName, customData, fbParams)
}

export const FBPixel = {
  init,
  isInited,
  track,
}
